module.exports = __webpack_public_path__ + "./assets/3-74f116.bmp";


//////////////////
// WEBPACK FOOTER
// ./assets/3.bmp
// module id = 21
// module chunks = 0